import { FC } from 'react';
import BasicSelect from 'further-ui/components/BasicSelect';
import api from 'lib/trpcClient';

type Props = {
  value?: string;
  onChange: (roleId: string) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  placeholder?: string;
};

export const AdminUserRoleSelector: FC<Props> = ({
  value,
  onChange,
  disabled,
  error,
  helperText,
  fullWidth = true,
  placeholder,
}) => {
  const { data: availableRoles, isLoading } =
    api.adminUser.listAvailableRolesForCurrentFirm.useQuery();

  const options = availableRoles
    ? availableRoles.map((role) => ({
        label: role.name,
        value: role.auth0RoleId,
        description: role.description ?? '',
      }))
    : [];

  return (
    <BasicSelect
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled || isLoading}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      placeholder={placeholder}
      noOptionsMessage="No roles available"
    />
  );
};

export default AdminUserRoleSelector;
